var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plan-deposits"},_vm._l((_vm.deposits),function(transaction){return _c('transaction',{key:transaction._id,staticClass:"plan-deposits-transaction",attrs:{"transaction":_vm.depositTransaction(transaction),"can-edit-category":false}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }